import { useMutation } from '@gogame/query';

import { exportSkanScheme } from 'scenes/SkanSchemes/sources/skan-schemes';

import { exportKey } from '../queryKeyFactory';

export const useExportSkanScheme = () => {
  const downloadSkanSchemeMutation = useMutation(
    exportKey(),
    exportSkanScheme,
    {
      successMessage: () => 'SKAN scheme download completed',
      refresh: false,
    }
  );

  const handleAction = async ({ id }) => {
    await downloadSkanSchemeMutation.mutateAsync({ id });
  };

  return [handleAction, downloadSkanSchemeMutation];
};
